import { CatalogLayout } from '@/components/catalog/CatalogLayout'

export function CatalogPage() {
  return (
    <div className="flex h-full flex-col">
      <CatalogLayout />
    </div>
  )
}
